import axios from 'axios';

class APIService {
    constructor() {
        this.token = null;
    }

    fetch = async (payload = {}) => {
        const { url, method, data, headers, ...rest} = payload
        return await axios({
            url,
            method,

            data: (method.toUpperCase() == 'GET' || method.toUpperCase() == 'DELETE' || data instanceof FormData ? (data || {}) : JSON.stringify(data)),
            headers: {
                ...(method.toUpperCase() == "GET" || method.toUpperCase() == 'DELETE' ? {} : { 'Content-Type': 'application/json' }),
                ...(headers || {}),
                ...(sessionStorage.getItem('cctoken') ? { "Authorization": `Bearer ${sessionStorage.getItem('cctoken')}` } : {})
            },
            ...rest
        }).then(res => {
            return res
        }).catch(err => {
            if (err.response.status == 401 || err.response.status == 403) {
                sessionStorage.clear();
                window.location.href = '/';
            }
            throw(err.response)
        })
    }
}

export default new APIService()